// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#main[data-v-23a9d030],.table-multiple[data-v-23a9d030]{border-radius:5px}.table-multiple[data-v-23a9d030]{overflow-x:scroll}.form-select[data-v-23a9d030]:disabled{background-color:#686869}", ""]);
// Exports
module.exports = exports;
